const searchIndex = [
  {
    keyword: "custom payments page",
    locations: [
      { name: "Projects Page", link: "/projects", description: "Located in the 'Custom Payments PAGE' project." },
      { name: "Payment Integration Section", link: "/projects#payment-integration", description: "Details about payment integration." },
    ],
  },
  {
    keyword: "resume",
    redirect: "/resume",
    response: `Sure! Resume can be accessed by navigating to the Resume on the navigation bar at the top. \n Or type "/resume" in the URL to directly go to the Resume page.`,
  },
  {
    keyword: "contact",
    locations: [
      { name: "Contact Page", link: "/contact", description: "Reach out to me through the Contact page." },
      { name: "Footer Section", link: "/contact#footer", description: "Contact information available in the footer." },
    ],
    response: "Feel free to contact me \n via the [Contact Page](/contact).",
  },
  {
    keyword: "projects",
    locations: [
      { name: "Projects Page", link: "/projects", description: "Explore all my projects here." },
      { name: "Home Page", link: "/#projects", description: "Featured projects showcased on the home page." },
    ],
    response: `Check out my projects [here](/projects).`,
  },
  {
    keyword: "about",
    locations: [
      { name: "About Page", link: "/about", description: "Learn more about me on the About page." },
      { name: "Navbar", link: "/about", description: "Navigate to the About page using the navbar." },
    ],
  },
  {
    keyword: "blog",
    locations: [
      { name: "Blog Page", link: "/blog", description: "Read my latest blog posts here." },
      { name: "Footer Section", link: "/blog#footer", description: "Access the blog from the footer." },
    ],
  },
  {
    keyword: "skills",
    locations: [
      { name: "Skills Section", link: "/about#skills", description: "Overview of my professional skills." },
      { name: "Resume Page", link: "/resume#skills", description: "Detailed skills listed in the resume." },
    ],
  },
  {
    keyword: "portfolio",
    locations: [
      { name: "Home Page", link: "/#portfolio", description: "View my portfolio on the home page." },
      { name: "Portfolio Page", link: "/portfolio", description: "Comprehensive portfolio showcasing my work." },
    ],
  },
  {
    keyword: "testimonials",
    locations: [
      { name: "Testimonials Section", link: "/about#testimonials", description: "Read feedback from my clients." },
      { name: "Home Page", link: "/#testimonials", description: "Highlighted testimonials on the home page." },
    ],
  },
  {
    keyword: "services",
    locations: [
      { name: "Services Page", link: "/services", description: "Details about the services I offer." },
      { name: "Navbar", link: "/services", description: "Access services via the navbar." },
    ],
  },
  {
    keyword: "portfolio modern",
    locations: [
      { name: "Home Page", link: "/#portfolio-modern", description: "Introduction to the Portfolio Modern project." },
      { name: "Projects Page", link: "/projects#portfolio-modern", description: "Details and showcases of the Portfolio Modern project." },
    ],
  },
  {
    keyword: "dark mode",
    locations: [
      { name: "Theme Toggle Button", link: "/settings#theme-toggle", description: "Switch between dark and light modes." },
      { name: "Settings Page", link: "/settings#theme", description: "Manage theme preferences in settings." },
    ],
  },
  {
    keyword: "language switcher",
    locations: [
      { name: "Header", link: "/settings#language-switcher", description: "Change language using the language switcher in the header." },
      { name: "Settings Page", link: "/settings#language", description: "Select preferred language in settings." },
    ],
  },
  {
    keyword: "responsive design",
    locations: [
      { name: "About Page", link: "/about#responsive-design", description: "Information about responsive design practices." },
      { name: "Projects Page", link: "/projects#responsive-design", description: "Projects showcasing responsive design." },
    ],
  },
  {
    keyword: "seo optimization",
    locations: [
      { name: "Blog Page", link: "/blog#seo-optimization", description: "Posts related to SEO optimization." },
      { name: "Home Page", link: "/#seo-optimization", description: "Overview of SEO strategies implemented." },
    ],
  },
  {
    keyword: "contact form",
    locations: [
      { name: "Contact Page", link: "/contact#form", description: "Send messages using the contact form." },
      { name: "Footer Section", link: "/contact#form", description: "Quick access to the contact form from the footer." },
    ],
  },
  {
    keyword: "github",
    locations: [
      { name: "About Page", link: "/about#github", description: "Learn more about my GitHub projects and contributions." },
      { name: "Navbar", link: "/about#github", description: "Access my GitHub profile from the navbar." },
    ],
    response: "You can view my GitHub projects on the [About Page](/about#github).",
  },
  {
    keyword: "linkedin",
    locations: [
      { name: "About Page", link: "/about#linkedin", description: "Learn more about my professional background on LinkedIn." },
      { name: "Navbar", link: "/about#linkedin", description: "Access my LinkedIn profile from the navbar." },
    ],
    response: "Connect with me on LinkedIn via the [About Page](/about#linkedin).",
  },
  {
    keyword: "contact email",
    locations: [
      { name: "Contact Page", link: "/contact#email", description: "Send an email directly from the contact page." },
      { name: "Footer Section", link: "/contact#email", description: "Click to email me from the footer." },
    ],
    response: "You can send me an email through the [Contact Page](/contact#email).",
  },
  {
    keyword: "portfolio showcase",
    locations: [
      { name: "Portfolio Page", link: "/portfolio#showcase", description: "Gallery of my work in the portfolio showcase." },
      { name: "Home Page", link: "/#portfolio-showcase", description: "Featured projects in the portfolio showcase." },
    ],
  },
  {
    keyword: "blog articles",
    locations: [
      { name: "Blog Page", link: "/blog", description: "Read my latest blog articles." },
      { name: "Home Page", link: "/#blog", description: "Highlights of recent blog articles." },
    ],
  },
  {
    keyword: "hire me",
    locations: [
      { name: "Contact Page", link: "/contact#hire-me", description: "Contact me to discuss hiring opportunities." },
      { name: "About Page", link: "/about#hire-me", description: "Invitation to hire me on the About page." },
    ],
    response: "Interested in working together? Visit the [Contact Page](/contact#hire-me) to get in touch.",
  },
  {
    keyword: "testimonial reviews",
    locations: [
      { name: "Testimonials Section", link: "/about#testimonials", description: "Customer reviews and testimonials." },
      { name: "Home Page", link: "/#testimonials", description: "Selected testimonial reviews on the home page." },
    ],
  },
  {
    keyword: "software development",
    locations: [
      { name: "Services Page", link: "/services#software-development", description: "Details about software development services." },
      { name: "About Page", link: "/about#software-development", description: "My experience in software development." },
    ],
    response: "I offer comprehensive software development services. Learn more on the [Services Page](/services#software-development).",
  },
  {
    keyword: "web design",
    locations: [
      { name: "Services Page", link: "/services#web-design", description: "Information about web design services." },
      { name: "Portfolio Page", link: "/portfolio#web-design", description: "Gallery of web design projects." },
    ],
    response: "Explore my web design services on the [Services Page](/services#web-design) and view projects on the [Portfolio Page](/portfolio#web-design).",
  },
  {
    keyword: "app development",
    locations: [
      { name: "Services Page", link: "/services#app-development", description: "Details on app development services." },
      { name: "Projects Page", link: "/projects#app-development", description: "Showcase of app development projects." },
    ],
    response: "Discover my app development offerings on the [Services Page](/services#app-development) and see projects on the [Projects Page](/projects#app-development).",
  },
  {
    keyword: "digital marketing",
    locations: [
      { name: "Services Page", link: "/services#digital-marketing", description: "Overview of digital marketing services." },
      { name: "Blog Page", link: "/blog#digital-marketing", description: "Articles related to digital marketing strategies." },
    ],
    response: "Learn about my digital marketing services on the [Services Page](/services#digital-marketing) and read related articles on the [Blog Page](/blog#digital-marketing).",
  },
  {
    keyword: "graphic design",
    locations: [
      { name: "Services Page", link: "/services#graphic-design", description: "Information about graphic design services." },
      { name: "Portfolio Page", link: "/portfolio#graphic-design", description: "Gallery of graphic design projects." },
    ],
    response: "Explore my graphic design services on the [Services Page](/services#graphic-design) and view projects on the [Portfolio Page](/portfolio#graphic-design).",
  },
  {
    keyword: "keyword or phrase",
    locations: [
      { name: "Page or Section Name", link: "/path", description: "Brief description." },
      // ...more locations if applicable
    ],
  },
  {
    keyword: "how to contact",
    locations: [
      { name: "Contact Page", link: "/contact", description: "Find various ways to reach out." },
    ],
    response: "You can contact me through the [Contact Page](/contact) via email or the contact form.",
  },
  {
    keyword: "list of projects",
    locations: [
      { name: "Projects Page", link: "/projects", description: "Explore all my projects here." },
    ],
    response: "View the full list of my projects on the [Projects Page](/projects).",
  },
  {
    keyword: "theme",
    response: "You can toggle between dark and light modes using the theme switch on the [Settings Page](/settings#theme-toggle).",
  },
  {
    keyword: "language",
    response: "You can change the website language using the language selector on the [Settings Page](/settings#language).",
  },
  // ...add more keywords and their locations as needed
];

export default searchIndex;